(function (root) {
  'use strict';
  var belt = 'kinecore-back-brace', relief = 'kinecore-relief-belt', ems = 'kinecore-ems-pain-reliever';
  var cdn = 'https://cdn.shopify.com/s/files/1/0996/0534/8671/files/';
  function label(en, es, lang) { return (lang || '').split('-')[0] === 'es' ? es : en; }
  function rows(items, lang) {
    var groups = {}, used = new Set(), output = [];
    items.forEach(function (it) {
      var p = it.properties || {};
      if (p.Package !== 'Premium' || (it.handle !== belt && it.handle !== relief && it.handle !== ems)) return;
      var id = p._kc_bundle || 'legacy';
      (groups[id] || (groups[id] = [])).push(it);
    });
    items.forEach(function (it) {
      if (used.has(it.key)) return;
      var p = it.properties || {}, group = groups[p._kc_bundle || 'legacy'];
      var main = group && group.find(function (x) { return (x.handle === belt || x.handle === relief); });
      var extra = group && group.find(function (x) { return x.handle === ems; });
      var mains = group ? group.filter(function (x) { return (x.handle === belt || x.handle === relief); }) : [];
      var extras = group ? group.filter(function (x) { return x.handle === ems; }) : [];
      var quantityOf = function (list) { return list.reduce(function (sum, x) { return sum + x.quantity; }, 0); };
      var premium = p.Package === 'Premium' && main && extra && mains.every(function (x) { return signature(x) === signature(main); }) && extras.every(function (x) { return signature(x) === signature(extra); }) && quantityOf(mains) === quantityOf(extras) && group.includes(it);
      var basic = (it.handle === belt || it.handle === relief) && p.Package === 'Basic';
      if (!premium && !basic) { output.push(it); return; }
      var parts = premium ? mains.concat(extras) : items.filter(function (x) { return signature(x) === signature(it); });
      parts.forEach(function (x) { used.add(x.key); });
      var isRelief = (premium ? main : it).handle === relief;
      var name = (isRelief ? label('Relief Belt – ', 'Faja Relief – ', lang) : label('Back Support Belt – ', 'Faja lumbar – ', lang)) + (premium ? 'Premium' : 'Basic');
      output.push(Object.assign({}, premium ? main : it, {
        product_title: name, title: name, components: parts, packageType: premium ? 'Premium' : 'Basic',
        quantity: premium ? quantityOf(mains) : quantityOf(parts),
        image: cdn + (isRelief ? (premium ? 'kc-relief-premium-combo-0911.png' : 'kc-relief-v4-es-10.png') : (premium ? 'kinecore-buybox-combo-0910.png' : 'kinecore-buybox-belt-0910.png')),
        final_line_price: parts.reduce(function (sum, x) { return sum + x.final_line_price; }, 0),
        packageDescription: premium ? label('Belt + EMS included · 3-year warranty', 'Faja + EMS incluidos · 3 años de garantía', lang) : label('Belt · 1-year warranty', 'Faja · 1 año de garantía', lang)
      }));
    });
    return output;
  }
  function count(items, lang) { return rows(items, lang).reduce(function (n, it) { return n + it.quantity; }, 0); }
  function path(file) { return ((root.Shopify && root.Shopify.routes && root.Shopify.routes.root) || '/') + file; }
  function lang() { return root.document.documentElement.lang; }
  function failure() { return label('Could not update your package. Please try again.', 'No se pudo actualizar tu paquete. Vuelve a intentarlo.', lang()); }
  async function request(file, data) {
    var res = await root.fetch(path(file), data ? { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) } : { cache: 'no-store' });
    var json = await res.json();
    if (!res.ok || json.status >= 400) throw new Error(json.description || failure());
    return json;
  }
  function signature(it) {
    var p = it.properties || {};
    return String(it.variant_id) + JSON.stringify(Object.keys(p).sort().map(function (k) { return [k, p[k]]; })) + JSON.stringify(it.selling_plan_allocation || null);
  }
  function matches(cart, original) { return cart.items.filter(function (it) { return signature(it) === signature(original); }); }
  function quantity(cart, original) { return matches(cart, original).reduce(function (n, it) { return n + it.quantity; }, 0); }
  async function setTargets(cart, targets) {
    var additions = [];
    targets.forEach(function (target) {
      var more = target.quantity - quantity(cart, target.original);
      if (more > 0) additions.push({ id: target.original.variant_id, quantity: more, properties: target.original.properties || {} });
    });
    if (additions.length) { await request('cart/add.js', { items: additions }); cart = await request('cart.js'); }
    var updates = {};
    targets.forEach(function (target) {
      var remaining = target.quantity;
      matches(cart, target.original).forEach(function (it) {
        var keep = Math.min(remaining, it.quantity);
        if (keep !== it.quantity) updates[it.key] = keep;
        remaining -= keep;
      });
    });
    if (Object.keys(updates).length) cart = await request('cart/update.js', { updates: updates });
    if (targets.some(function (target) { return quantity(cart, target.original) !== target.quantity; })) throw new Error(failure());
    return cart;
  }
  var busy = false;
  function lock(on) {
    busy = on;
    root.document.querySelectorAll('#au-drawer-items button, #au-drawer-items input, [data-kc-cart-page] button, [data-kc-cart-page] input').forEach(function (el) { el.disabled = on; });
    root.document.documentElement.classList.toggle('kc-cart-updating', on);
  }
  async function change(key, quantity) {
    if (busy) throw new Error(failure());
    if (!Number.isInteger(quantity) || quantity < 0) throw new Error(failure());
    lock(true);
    var snapshot = [];
    try {
      var cart = await request('cart.js');
      var row = rows(cart.items, lang()).find(function (it) { return it.key === key; });
      if (!row) throw new Error(failure());
      if (!row.components) return await request('cart/change.js', { id: key, quantity: quantity });
      var identities = new Set();
      row.components.forEach(function (part) {
        var id = signature(part);
        if (!identities.has(id)) { identities.add(id); snapshot.push({ original: part, quantity: matches(cart, part).reduce(function (n, it) { return n + it.quantity; }, 0) }); }
      });
      return await setTargets(cart, snapshot.map(function (target) { return { original: target.original, quantity: quantity }; }));
    } catch (error) {
      if (snapshot.length) {
        try {
          var latest = await request('cart.js');
          await setTargets(latest, snapshot);
        } catch (restoreError) { error = new Error(label('Your cart changed. Please check its contents before checkout.', 'Tu carrito ha cambiado. Revisa su contenido antes de pagar.', lang())); }
      }
      throw error;
    } finally { lock(false); }
  }
  function escape(value) { return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function showError(error) {
    var host = root.document.querySelector('#au-drawer.show #au-drawer-items') || root.document.querySelector('[data-kc-cart-page]');
    if (!host) return;
    var el = host.querySelector('[data-kc-cart-error]');
    if (!el) { el = root.document.createElement('p'); el.dataset.kcCartError = ''; el.setAttribute('role', 'alert'); host.prepend(el); }
    el.textContent = error.message || failure();
  }
  async function pageCart() {
    var host = root.document.querySelector('[data-kc-cart-page]');
    if (!host || host.dataset.kcWired) return;
    var form = host.querySelector('form'), list = host.querySelector('.jt-cartlist');
    if (!form || !list) return;
    host.dataset.kcWired = 'true';
    var cart;
    function money(cents) { return root.jtFormatMoney ? root.jtFormatMoney(cents) : new Intl.NumberFormat(lang(), { style: 'currency', currency: cart.currency || 'EUR' }).format(cents / 100); }
    function paint() {
      list.innerHTML = rows(cart.items, lang()).map(function (it) {
        return '<div class="jt-cartrow" data-kc-row="' + escape(it.key) + '"><a href="' + escape(it.url) + '" class="jt-cartrow-im"><img src="' + escape(it.image) + '" alt="" width="80" height="80"></a><div class="jt-cartrow-tx"><a href="' + escape(it.url) + '"><b>' + escape(it.product_title) + '</b></a><span>' + escape(it.variant_title === 'Default Title' ? '' : it.variant_title) + '</span><span>' + escape(it.packageDescription || '') + '</span><div class="jt-cartrow-price">' + escape(money(it.final_line_price)) + '</div></div><div class="jt-cartrow-end"><div class="jt-qty"><input type="number" min="0" step="1" value="' + it.quantity + '" aria-label="' + escape(label('Quantity for ', 'Cantidad de ', lang()) + it.product_title) + '"></div><button type="button" class="jt-cartrow-rm" data-kc-remove>' + escape(label('Remove', 'Eliminar', lang())) + '</button></div></div>';
      }).join('');
      var total = host.querySelector('.jt-cartsum > div b');
      if (total) total.textContent = money(cart.items_subtotal_price);
    }
    try { cart = await request('cart.js'); paint(); } catch (e) { delete host.dataset.kcWired; return; }
    async function apply() {
      var beforeRows = rows(cart.items, lang());
      var desired = Array.from(list.querySelectorAll('[data-kc-row]')).map(function (el) { return { original: beforeRows.find(function (it) { return it.key === el.dataset.kcRow; }), quantity: Number(el.querySelector('input').value) }; });
      for (var d of desired) {
        var existing = rows(cart.items, lang()).find(function (it) { return d.original && signature(it) === signature(d.original); });
        if (existing && existing.quantity !== d.quantity) cart = await change(existing.key, d.quantity);
      }
      if (!cart.items.length) { root.location.reload(); return; }
      paint();
      if (root.auRenderCart) root.auRenderCart();
    }
    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (busy) return;
      var checkout = event.submitter && event.submitter.name === 'checkout';
      try { await apply(); if (checkout) root.location.assign(path('checkout')); }
      catch (e) { cart = await request('cart.js'); paint(); showError(e); }
    });
    list.addEventListener('click', async function (event) {
      var button = event.target.closest('[data-kc-remove]');
      if (!button || busy) return;
      try { cart = await change(button.closest('[data-kc-row]').dataset.kcRow, 0); if (!cart.items.length) root.location.reload(); else paint(); if (root.auRenderCart) root.auRenderCart(); }
      catch (e) { cart = await request('cart.js'); paint(); showError(e); }
    });
  }
  var api = { rows: rows, count: count, change: change, escape: escape, showError: showError };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (root.document) {
    root.KCPackageCart = api;
    root.document.addEventListener('click', function (e) { if (busy && e.target.closest('a[href*="checkout"], button[name="checkout"]')) { e.preventDefault(); e.stopImmediatePropagation(); } }, true);
    if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', pageCart); else pageCart();
  }
})(typeof window === 'undefined' ? globalThis : window);